import { GridColDef, GridColumnVisibilityModel, GridSortModel } from '@mui/x-data-grid';
import { AccessRequest } from '@synergetx/puppet-interview-types';
import { format } from 'date-fns/format';

export const ACCESS_REQUESTS_COLUMNS: GridColDef<AccessRequest>[] = [
    {
        field: 'name',
        headerName: 'Name',
        flex: 1,
    },
    {
        field: 'email',
        headerName: 'Email',
        flex: 1,
    },
    {
        field: 'id',
        headerName: 'ID',
        width: 280,
    },
    {
        field: 'ageGroup',
        headerName: 'Age Group',
        width: 120,
    },
    {
        field: 'assignedGroupId',
        headerName: 'Assigned Group Id',
        width: 200,
    },
    {
        field: 'assignedGroupName',
        headerName: 'Assigned Group Name',
        width: 180,
    },
    {
        field: 'country',
        headerName: 'Country',
        width: 120,
    },
    {
        field: 'language',
        headerName: 'Language',
        width: 120,
    },
    {
        field: 'organization',
        headerName: 'Organization',
        width: 150,
    },
    {
        field: 'status',
        headerName: 'Approval Status',
        width: 130,
    },
    {
        field: 'studyDescription',
        headerName: 'Study Description',
        width: 200,
    },
    {
        field: 'userIdRequestingAccess',
        headerName: 'User Id Requesting Access',
        width: 220,
    },
    {
        field: 'createdAt',
        headerName: 'Created At',
        width: 180,
        valueFormatter: (value: number) => (value ? format(value, 'Pp') : ''),
    },
];

export const ACCESS_REQUESTS_COLUMN_VISIBILITY: GridColumnVisibilityModel = {
    ageGroup: false,
    assignedGroupId: false,
    assignedGroupName: false,
    country: false,
    language: false,
    organization: false,
    status: false,
    studyDescription: false,
    userIdRequestingAccess: false,
};

export const ACCESS_REQUESTS_INITIAL_SORT: GridSortModel = [{ field: 'createdAt', sort: 'desc' }];

/** All columns to include in CSV export (including hidden ones) */
export const ACCESS_REQUESTS_EXPORT_COLUMNS = ACCESS_REQUESTS_COLUMNS.map((col) => col.field);
